export function start(chatId) {
    return {
        type: 'TRADER_CHAT_TYPING_START',
        chatId
    };
}

export function stop(chatId) {
    return {
        type: 'TRADER_CHAT_TYPING_STOP',
        chatId
    };
}
